import { Reveal, Eyebrow } from "./Reveal";
import { Quote } from "lucide-react";

const IMG =
  "https://customer-assets-lqy194kg.emergentagent.net/job_construction-hub-734/artifacts/nzcobrjr_g4.jpeg";

export const About = () => (
  <section id="about" className="scroll-mt-24 bg-[#0B0C0E] py-24 sm:py-32">
    <div className="mx-auto grid max-w-7xl gap-16 px-5 sm:px-8 lg:grid-cols-2 lg:items-center">
      <Reveal>
        <div className="relative">
          <div className="absolute -left-3 -top-3 h-full w-full border border-[#FFFFFF]/40" aria-hidden="true" />
          <img
            src={IMG}
            alt="Gativan site team executing reinforcement work on a live project"
            className="relative aspect-[4/5] w-full object-cover"
            loading="lazy"
          />
          <div className="absolute bottom-5 left-5 bg-black/70 px-4 py-2 font-mono text-xs uppercase tracking-[0.25em] text-[#FFFFFF] backdrop-blur">
            UK Realty · Live Site Operations
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <Eyebrow>Since 2019 · The Legacy</Eyebrow>
          <h2 className="mt-4 font-display text-4xl font-extrabold uppercase tracking-tight text-[#F3F4F6] sm:text-5xl">
            Built on precision. <span className="text-[#FFFFFF]">Run on trust.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-base leading-relaxed text-[#9CA3AF] sm:text-lg">
            Founded in 2019, Gativan Office has grown from a specialist electrical contractor into a
            multidisciplinary engineering partner — delivering electrical infrastructure, industrial
            plumbing and custom commercial furniture for institutional and real-estate landmarks.
          </p>
          <p className="mt-4 text-base leading-relaxed text-[#9CA3AF] sm:text-lg">
            From the Radius Company tower in Noida to the RIMS Hospital electrical systems in Manipur,
            we are currently executing multiple projects for UK Realty — on time, every time.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <figure className="mt-10 border-l-2 border-[#FFFFFF] pl-6">
            <Quote size={20} className="mb-3 text-[#FFFFFF]" />
            <blockquote className="font-display text-2xl font-bold uppercase leading-snug tracking-tight text-[#F3F4F6]">
              "Every wire, every pipe, every joint — engineered to outlast the building itself."
            </blockquote>
            <figcaption className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-[#9CA3AF]">
              Vinod Tripathy · Founder, Gativan Office
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);
